import { fmt } from '@k2pos/core';
import { useNavigate } from 'react-router-dom';
import { HazardStripes } from '@/components/brand/HazardStripes';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Mono, Text } from '@/components/ui/Text';
import { IconCheck } from '@/components/icons';
import { usePos } from '@/store/pos';
import { colors } from '@/theme/tokens';
import styles from './ReceiveDone.module.css';

/** Receipt for a payment taken, plus the statement the owner sends the customer. */
export function ReceiveDone() {
  const navigate = useNavigate();
  const receipt = usePos((s) => s.lastReceipt);

  // `lastReceipt` is not persisted, so a cold start lands here. That is correct:
  // resurrecting the last receipt would read as a duplicate payment.
  if (!receipt) {
    return (
      <div className={styles.centered}>
        <Text size={13} color={colors.textMuted}>
          ບໍ່ມີໃບຮັບລ່າສຸດ
        </Text>
        <Button
          label="ກັບໜ້າໜີ້"
          className={styles.wide}
          onPress={() => navigate('/debt', { replace: true })}
        />
      </div>
    );
  }

  const closed = receipt.remaining === 0;

  return (
    <>
      <div className={styles.success}>
        <HazardStripes className={styles.stripes} opacity={0.3} period={18} />
        <div className={styles.check}>
          <IconCheck size={26} />
        </div>
        <Text weight={800} size={17} color={colors.onDark}>
          ຮັບເງິນ {fmt(receipt.amount)} ₭
        </Text>
      </div>

      <div className={`${styles.body} vscroll`}>
        <Card elevated className={styles.summary}>
          <Text weight={800} size={13}>
            ໃບສະຫຼຸບໜີ້ · {receipt.customerName}
          </Text>

          <div className={styles.summaryRow}>
            <Text size={12.5} color={colors.textMuted}>
              ຮັບຊຳລະ
            </Text>
            <Mono weight={700} size={14} color={colors.navy} className="selectable">
              −{fmt(receipt.amount)}
            </Mono>
          </div>

          <div className={styles.dash} />

          <div className={styles.summaryRow}>
            <Text weight={800} size={14}>
              ຄ້າງ
            </Text>
            <Mono weight={700} size={18} color={colors.skyDeep} className="selectable">
              {fmt(receipt.remaining)} ₭
            </Mono>
          </div>
        </Card>

        {closed ? (
          <div className={styles.closed}>
            <IconCheck size={17} />
            <Text weight={800} size={14} color={colors.sky}>
              ປິດໜີ້ແລ້ວ
            </Text>
          </div>
        ) : null}

        <div className={styles.actions}>
          <Button
            label="ກັບໜ້າໜີ້"
            className="grow"
            onPress={() => navigate('/debt', { replace: true })}
          />
          <Button
            label="ສົ່ງໃບສະຫຼຸບ"
            variant="outline"
            className="grow"
            onPress={() => navigate('/debt', { replace: true })}
          />
        </div>
      </div>
    </>
  );
}
